import { useStyleSheet } from '../../../../../../../../hooks/useStyleSheet';
import { OptionCountProps } from './OptionCount.types';

export const useStyles = ({ isActive, count }: OptionCountProps) => {
  const styles = useStyleSheet(
    (theme) => {
      const getColors = () => {
        if (isActive) {
          return {
            borderColor: theme.palette.common.white,
            backgroundColor: 'transparent',
            color: theme.palette.common.white,
          };
        }

        return {
          borderColor: 'transparent',
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.common.white,
        };
      };

      const { backgroundColor, color, borderColor } = getColors();

      return {
        root: {
          borderStyle: 'solid',
          borderWidth: '1px',
          borderColor,
          width: '1.2rem',
          height: '1.2rem',
          backgroundColor,
          display: 'grid',
          placeItems: 'center',
          borderRadius: '50%',
        },
        typography: {
          color,
        },
      };
    },
    [isActive, count],
  );

  return styles;
};
